import { render, staticRenderFns } from "./buyer-detail.vue?vue&type=template&id=78228f45&scoped=true&"
import script from "./buyer-detail.vue?vue&type=script&lang=js&"
export * from "./buyer-detail.vue?vue&type=script&lang=js&"
import style0 from "./buyer-detail.vue?vue&type=style&index=0&id=78228f45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78228f45",
  null
  
)

export default component.exports